export class DigitalSignatureStruct {
    public idSignatureProvider: number;
    public idUser: number;
    public idHealthUnit: number;
}
